export enum MESSAGE_TYPES {
    Dictionary = "dictionary",
    Chat = "chat",
    Leitner = "leitner",
    Quiz = "quiz",
    Idiom = "idiom",
    Partner = "partner",
    Puzzle = "puzzle",
    Document = "document",
    News = "news",
    Story = "story",
    Lesson = "lesson",
    ArtikelQuiz = "artikelQuiz",
    ImageQuiz = "imageQuiz",
    TranslationQuiz = "translationQuiz",
    InteractiveChatJourney = "interactiveChatJourney",
    AdsMessage = "adsMessage",
}